import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { useState, useRef, useEffect } from 'react';
import React from 'react';
interface IProps {
  contactNumber?: number;
  onChange?: any;
  open?: boolean;
}

const FixedDialCodePhoneInput = ({ contactNumber, onChange, open }: IProps) => {
  const [value, setValue] = useState<any>('');
  const inputRef = useRef<HTMLInputElement>(null);
  const [dialCode, setDialCode] = useState('+61'); // default là Úc

  const handleChange = (val: string, data: any) => {
    const newDialCode = `+${data?.dialCode}`;
    setDialCode(newDialCode);
    onChange(val);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    const pos = inputRef.current?.selectionStart || 0;
    if (pos <= dialCode.length && (e.key === 'Backspace' || e.key === 'Delete')) {
      e.preventDefault(); // Ngăn xóa mã vùng
    }
  };

  useEffect(() => {
    setValue(contactNumber);
  }, [contactNumber, dialCode]);

  return (
    <PhoneInput
      // country={isShowCountry ? 'au' : ''}
      value={value}
      onChange={handleChange}
      inputProps={{
        ref: inputRef,
        onKeyDown: handleKeyDown,
        required: true,
        name: 'phone',
      }}
    />
  );
};

export default FixedDialCodePhoneInput;
